import * as core from '../../../../../../../core'

import { query } from './stakeholder-details-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholder.details.modal',
    description: 'Modal for viewing the details of a stakeholder',
    name: 'Stakeholder Details Modal',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
